import { render } from "./ZIndex.vue?vue&type=template&id=4b3573e2"
import script from "./ZIndex.vue?vue&type=script&lang=ts"
export * from "./ZIndex.vue?vue&type=script&lang=ts"
script.render = render

export default script